import React from "react";
import style from "./modal-component.module.css";

const ModalComponent = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className={style["modal-overlay"]} onClick={onClose}>
      <div
        className={style["modal-content"]}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
      >
        <button className={style["modal-close"]} onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalComponent;
